import React from 'react'
import { Button, ButtonProps, PositionProps } from '@chakra-ui/react' // Added Tooltip import
import { faInfo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Tooltip } from 'antd'

type Props = {
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    icon?: IconProp;
    bottom?: ButtonProps['bottom'];
    right?: ButtonProps['right'];
    bg?: ButtonProps['bg'];
    _hover?: ButtonProps['_hover'];
    color?: ButtonProps['color'];
    size?: ButtonProps['size'];
    position?: PositionProps;
    tooltipLabel?: string;
}

const FloatButtonComp: React.FC<Props> = ({
    onClick = () => { },
    icon = faInfo,
    bottom = '20px',
    right = '20px',
    bg = "green.400",
    color = "white",
    _hover = { bg: "green.600" },
    size = 'md',
    tooltipLabel
}: Props) => {
    return (
        <Tooltip title={tooltipLabel} aria-label={tooltipLabel} placement='left'>
            <Button
                style={{ zIndex: 1000 }}
                position="fixed"
                bottom={bottom}
                right={right}
                bg={bg}
                color={color}
                _hover={_hover}
                size={size}
                borderRadius="full"
                boxShadow="md"
                onClick={onClick}
            >
                <FontAwesomeIcon icon={icon} />
            </Button>
        </Tooltip>
    )
}

export default FloatButtonComp